import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Skeleton,
  Stack
} from '@mui/material';
import adCenterApi from '../adCenterApi';
import { useNavigate } from 'react-router-dom';

export default function GetCampaign() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCampaigns = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await adCenterApi.post('/getCampaignByBroker', {
          adminUser: localStorage.getItem('uuid'),
          brokerId: localStorage.getItem('brokerId'),
          campaignStatus: 'ALL',
        });
        if (response.data && response.data.statusCode === 0) {
          setCampaigns(response.data.campaignDetails || []);
        } else {
          setError(response.data.message || 'Failed to fetch campaigns');
        }
      } catch (err) {
        setError('Error fetching campaigns');
      } finally {
        setLoading(false);
      }
    };
    fetchCampaigns();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mb: 6 }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1 }}>
          <Box>
            <Typography variant="h4" component="h1" fontWeight="bold" color="primary.main">
              Campaigns
            </Typography>
            <Typography variant="body1" color="text.secondary"
                          mt={0.5}
                          sx={{
                            fontStyle: 'italic'
            
                          }}>
                          View and manage all your campaigns in one place.
                        </Typography>
            
          </Box>
          <Button variant="contained" color="primary" sx={{ fontWeight: 'bold', textTransform: 'none', boxShadow: 2 }}
            onClick={() => navigate('/create-campaign')}
          >
            + Create New Campaign
          </Button>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Card elevation={6} sx={{ borderRadius: 3, boxShadow: 6 }}>
            <CardContent sx={{ p: { xs: 2, md: 4 } }}>
              {loading ? (
                <Stack spacing={2}>
                  {[...Array(5)].map((_, i) => (
                    <Skeleton key={i} variant="rectangular" height={48} sx={{ borderRadius: 2 }} />
                  ))}
                </Stack>
              ) : error ? (
                <Typography color="error">{error}</Typography>
              ) : (
                <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#222b36' }}>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Campaign Name</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Ad Type</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Campaign Description</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Call to Action</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Ad Headline</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Destination Url</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {campaigns.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={6} align="center">No campaigns found.</TableCell>
                        </TableRow>
                      ) : (
                        campaigns.map((row, idx) => (
                          <TableRow key={row.campaignId || idx} hover sx={{ transition: 'background 0.2s', '&:hover': { backgroundColor: 'grey.100' } }}>
                            <TableCell sx={{ fontWeight: 500 }}>{row.campaignName}</TableCell>
                            <TableCell sx={{ fontWeight: 500 }}>{row?.adType}</TableCell>
                            <TableCell>{row.campaignDescription}</TableCell>
                            <TableCell>{row.callToAction || '-'}</TableCell>
                            <TableCell>{row.mediaHeadline}</TableCell>
                            <TableCell>
                              {row.callToActionUrl ? (
                                <a href={row.callToActionUrl.replace(/\[|\]/g, '')} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline' }}>{row.callToActionUrl.replace(/\[|\]/g, '')}</a>
                              ) : '-'}
                            </TableCell>
                            <TableCell>
                              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                <Button variant="outlined" color="primary" size="small" sx={{ fontWeight: 'bold', borderRadius: 2 }}
                                  onClick={() => navigate('/edit-campaign', { state: { campaign: row } })}
                                >Edit</Button>
                                {/* <Button variant="outlined" color="error" size="small" sx={{ fontWeight: 'bold', borderRadius: 2 }}>Delete</Button> */}
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Container>
  );
}
